import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from './apiConfig';

const API = API_BASE_URL;

class PublisherService {
  getHeaders() {
    return {
      Authorization: `Bearer ${authService.getAccessToken()}`,
      'Content-Type': 'application/json'
    };
  }

  // Profile
  async getProfile() {
    const response = await axios.get(`${API}/publisher/profile`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async updateProfile(profileData) {
    const response = await axios.put(`${API}/publisher/profile`, profileData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Submissions
  async getSubmissions() {
    const response = await axios.get(`${API}/publisher/submissions`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async createSubmission(submissionData) {
    const response = await axios.post(`${API}/publisher/submissions/create`, submissionData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async updateSubmission(submissionId, updateData) {
    const response = await axios.put(`${API}/publisher/submissions/${submissionId}`, updateData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async addCourierRequest(submissionId, courierData) {
    const response = await axios.post(`${API}/publisher/submissions/${submissionId}/courier`, courierData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async submitForReview(submissionId) {
    const response = await axios.post(`${API}/publisher/submissions/${submissionId}/submit`, {}, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async requestFunding(submissionId, fundingData) {
    const response = await axios.post(`${API}/publisher/submissions/${submissionId}/request-funding`, fundingData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async getSubmissionTracker(submissionId) {
    const response = await axios.get(`${API}/publisher/submissions/${submissionId}/tracker`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Messages
  async getMessages() {
    const response = await axios.get(`${API}/publisher/messages`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async createMessage(messageData) {
    const response = await axios.post(`${API}/publisher/messages`, messageData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async updateMessage(messageId, status) {
    const response = await axios.put(`${API}/publisher/messages/${messageId}`, { status }, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Dashboard
  async getDashboardMetrics() {
    const response = await axios.get(`${API}/publisher/dashboard/metrics`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Public Profile
  async getPublicProfile(slug) {
    const response = await axios.get(`${API}/public/publishers/${slug}`);
    return response.data;
  }

  // Admin
  async adminApproveSubmission(submissionId) {
    const response = await axios.post(`${API}/admin/submissions/${submissionId}/approve`, {}, {
      headers: this.getHeaders()
    });
    return response.data;
  }
}

export default new PublisherService();
